


import { Component, Vue } from 'vue-property-decorator';

import InlineSpinner from '@/shared/components/inline-spinner.component.vue';

import Assets from '@/constants/assets.ts';

@Component({
    components: {
        InlineSpinner,
    },
})

export default class PartialInlineSpinner extends Vue {

  private assets = Assets;

}
